export default __webpack_public_path__ + "static/media/Group -6TataNeu@2x.e7675a45.png";